import { render } from "./inventoryManage.vue?vue&type=template&id=134306cb&scoped=true"
import script from "./inventoryManage.vue?vue&type=script&lang=js"
export * from "./inventoryManage.vue?vue&type=script&lang=js"

import "./inventoryManage.vue?vue&type=style&index=0&id=134306cb&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134306cb"]])

export default __exports__